import React from "react";

export default function SearchInput(props: { value: string, onChange: (v: string) => void, placeholder?: string }) {
    return (
        <div className="relative">
            <input
                type="text"
                value={props.value}
                placeholder={props.placeholder ?? "Search..."}
                onChange={(e) => props.onChange(e.target.value)}
                className="w-full rst-input pr-8"
            />
            {props.value && (
                <button
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-white"
                    onClick={() => props.onChange("")}>
                    ✕
                </button>
            )}
        </div>
    )
}
